import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export function useStickyShadow(threshold = 10) {
  const [stuck, setStuck] = useState(false);
  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return stuck;
}

export function GlassCard({ className = "", children }) {
  return (
    <Card
      className={
        "relative overflow-hidden rounded-2xl border-white/10 bg-white/[0.04] shadow-[0_24px_80px_rgba(0,0,0,0.55)] backdrop-blur-[18px] " +
        className
      }
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-[radial-gradient(circle_at_20%_0%,rgba(252,211,77,0.10),transparent_45%)]"
      />
      <div className="relative">{children}</div>
    </Card>
  );
}

export function GoldPillButton({ children, className = "", ...props }) {
  return (
    <Button
      {...props}
      className={
        "relative h-11 rounded-full bg-[linear-gradient(180deg,rgba(252,211,77,0.98),rgba(245,158,11,0.92))] px-6 text-[0.98rem] font-semibold text-[#15110A] shadow-[0_14px_40px_rgba(245,158,11,0.18)] transition-colors hover:bg-[linear-gradient(180deg,rgba(252,211,77,1),rgba(245,158,11,0.98))] focus-visible:ring-2 focus-visible:ring-[hsl(var(--utu-gold))]/40 disabled:opacity-60 " +
        className
      }
    >
      <span className="relative inline-flex items-center gap-2">
        {children}
      </span>
    </Button>
  );
}

export function OutlinePillButton({ children, className = "", ...props }) {
  return (
    <Button
      variant="outline"
      {...props}
      className={
        "h-11 rounded-full border-white/14 bg-white/5 px-6 text-[0.98rem] font-semibold text-white/90 backdrop-blur-xl transition-colors hover:bg-white/8 hover:text-white focus-visible:ring-2 focus-visible:ring-white/25 " +
        className
      }
    >
      <span className="inline-flex items-center gap-2">
        {children}
      </span>
    </Button>
  );
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
}
